import type { InvoiceSummary } from '../../types/invoice';

interface InvoiceSummarySectionProps {
  summary: InvoiceSummary;
}

export function InvoiceSummarySection({ summary }: InvoiceSummarySectionProps) {
  return (
    <div className="card-compact p-6">
      <h2 className="text-lg font-semibold mb-4 text-gray-900">Invoice Summary</h2>
      <div className="space-y-3">
        <div className="flex justify-between items-center py-2 border-b border-gray-200">
          <span className="text-sm text-gray-600">Total Line Items:</span>
          <span className="text-sm font-medium text-gray-900">{summary.totalLineItems}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-200">
          <span className="text-sm text-gray-600">Subtotal:</span>
          <span className="text-sm font-medium text-gray-900">${summary.subtotal}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-200">
          <span className="text-sm text-gray-600">Total Tax:</span>
          <span className="text-sm font-medium text-gray-900">${summary.totalTax}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-200">
          <span className="text-sm text-gray-600">Total Charges:</span>
          <span className="text-sm font-medium text-gray-900">${summary.totalCharges}</span>
        </div>
        <div className="flex justify-between items-center py-2 border-b border-gray-200">
          <span className="text-sm text-gray-600">Total Allowances:</span>
          <span className="text-sm font-medium text-gray-900 text-red-600">-${summary.totalAllowances}</span>
        </div>
        <div className="flex justify-between items-center py-3 bg-blue-50 rounded-lg px-4 mt-4">
          <span className="text-base font-semibold text-gray-900">Invoice Total:</span>
          <span className="text-xl font-bold text-blue-600">${summary.invoiceTotal}</span>
        </div>
      </div>
    </div>
  );
}
